<div
  [dir]="cService.selectedLanguage?.isRtl ? 'rtl' : 'ltr'"
  fxLayout='column'
  fxFill
  class='gallery-item-detail-container'
>
  <div
    fxLayout='column'
    [style.background-color]="'#' + cService.userProfile.HqColour"
    style='color: white; padding: 0 15px'
  >
    <div fxLayout='row' fxLayoutAlign='space-between' style='height: 45px; margin-top: 10px; opacity: 0.8'>
      <div
        mat-dialog-title
        class='margin-none force'
        fxLayout='row'
        fxFlex
        *ngIf='derMediaData && derMediaData.length'
      >
        <div class='file-info' *ngIf='selectedItem.media'>
          <img
            *ngIf='selectedItem.media.fileTypeIcons?.white'
            [src]='selectedItem.media.fileTypeIcons?.white'
            style='position: relative; top: 4px'
            width='24px'
            height='24px'
          />
          <mat-icon *ngIf='!selectedItem.media.fileTypeIcons?.white' style='position: relative; top: 4px'
          >image
          </mat-icon
          >
          &nbsp;
          <span>{{ selectedItem.media.generatedFileName }}</span>
          <small style='opacity: 0.5'>&nbsp; {{ currentIndex + 1 }} of {{ maxIndex + 1 }}</small>
        </div>
        <div class='file-info' *ngIf='selectedItem.map'>
          <mat-icon style='position: relative; top: 4px'>public</mat-icon>
          &nbsp;
          <span *ngIf='selectedItem.map'>{{ 'DER.eventLocation' | translate }}</span>
          <small style='opacity: 0.5'>&nbsp; {{ currentIndex + 1 }} of {{ maxIndex + 1 }}</small>
        </div>
        <span fxFlex></span>
        <a
          mat-icon-button
          [href]='selectedItem.media?.imageStream | trustAsSafeUrl'
          target='_blank'
          [disabled]='selectedItem.media?.imageStream ? false : true'
          [download]='selectedItem.media?.generatedFileName'
        >
          <mat-icon class='utility-icons'>download</mat-icon>
        </a>
      </div>

      <span *ngIf='!derMediaData || !derMediaData.length' fxFlex></span>
      <button
        mat-icon-button
        style='top: -10px; right: -15px'
        [style.backgroundColor]="'#' + cService.userProfile.HqColour"
        class='back-to-gallery-button'
        (click)='onBackToGalleryClicked()'
      >
        <mat-icon>grid_on</mat-icon>
      </button>
    </div>
  </div>

  <!-- Body -->
  <!-- Viewer Navigation -->
  <div>
    <div
      class='image-nav nav-left'
      *ngIf='currentIndex !== minIndex'
      [class.image-nav-mobile]='!cService.isPcViewport'
      fxLayout='column'
      (click)='navigateToPreviousImage()'
    >
      <span fxFlex='40'></span>
      <div class='image-nav-round-bg' [style.background]="'#' + cService.userProfile?.HqColour">
        <mat-icon>navigate_before</mat-icon>
      </div>
      <span fxFlex></span>
    </div>
    <div
      class='image-nav nav-right'
      *ngIf='currentIndex !== maxIndex'
      [class.image-nav-mobile]='!cService.isPcViewport'
      fxLayout='column'
      (click)='navigateToNextImage()'
    >
      <span fxFlex='40'></span>
      <div class='image-nav-round-bg' [style.background]="'#' + cService.userProfile?.HqColour">
        <mat-icon>navigate_next</mat-icon>
      </div>
      <span fxFlex></span>
    </div>
  </div>

  <div
    [fxLayout]="cService.isPcViewport ? 'row' : 'column'"
    class='content-details-container'
    *ngIf='selectedItem'
    fxFlex
  >
    <!-- Image viewer -->
    <div *ngIf='derMediaData && derMediaData.length' fxFlex class='image-viewer' fxLayout='column'>
      <!-- Image -->
      <span fxFlex></span>
      <div fxLayout='row' fxLayoutAlign='center'>
        <img
          data-ot-ignore
          class='image optanon-category'
          [src]='selectedItem.media.imageStream'
          *ngIf='selectedItem.media?.imageStream && selectedItem.media?.mediaType === mediaTypes.image'
        />

        <pdf-viewer
          style='width: 100%'
          [original-size]='false'
          [show-all]='true'
          [fit-to-page]='true'
          [autoresize]='true'
          [render-text]='true'
          [external-link-target]="'blank'"
          (after-load-complete)='pdfLoadComplete()'
          [src]='selectedItem.media.imageStream'
          *ngIf='selectedItem.media?.imageStream && selectedItem.media?.mediaType === mediaTypes.document'
        >
        </pdf-viewer>

        <audio
          controls
          controlsList='nodownload'
          [src]='selectedItem.media.imageStream | trustAsSafeUrl'
          *ngIf='selectedItem.media?.imageStream && selectedItem.media?.mediaType === mediaTypes.audio'
        ></audio>

        <div
          style='padding: 0 100px; width: 100%'
          *ngIf='selectedItem.media?.imageStream && selectedItem.media?.mediaType === mediaTypes.video'
        >
          <video
            style='width: 100%'
            [src]='selectedItem.media?.imageStream | trustAsSafeUrl'
            controls
            controlsList='nodownload'
          ></video>
        </div>

        <vrm-map
          class='gallery-item'
          *ngIf='selectedItem.map'
          [latitude]='selectedItem.map.latitude'
          [longitude]='selectedItem.map.longitude'
          [interactive]='true'
          [mapContainer]='mapContainer.galleryDetail'
          [zoom]='16'
        ></vrm-map>
      </div>

      <span fxFlex></span>
    </div>

    <div
      *ngIf='derMediaData && derMediaData.length'
      [fxFlex]="cService.isPcViewport ? '30' : ''"
      fxLayout='column'
      class='image-details-pane'
    >
      <!-- Title -->
      <div class='details-header'>{{ 'GENERIC.details' | translate | uppercase }}</div>

      <!-- Driver Information -->
      <div
        class='driver-details'
        *ngIf='selectedItem.media && (selectedItem.media.firstName || selectedItem.media.lastName || selectedItem.media.date)'
      >
        <div class='padding-b-15' *ngIf='selectedItem.media.firstName || selectedItem.media.lastName'>
          <div class='bold padding-b-5'>
            <small>{{ 'GENERIC.driver' | translate | uppercase }}</small>
          </div>
          <div>
            <small>{{ selectedItem.media.firstName + ' ' + selectedItem.media.lastName }}</small>
            <small *ngIf='selectedItem.media.pin'> - {{ selectedItem.media.pin }}</small>
          </div>
        </div>

        <div class='padding-b-15' *ngIf='selectedItem.media.title'>
          <div class='bold padding-b-5'>
            <small>{{ 'GENERIC.title' | translate | uppercase }}</small>
          </div>
          <div>
            <small>{{ selectedItem.media.title }}</small>
          </div>
        </div>

        <div class='padding-b-15' *ngIf='selectedItem.media.reason'>
          <div class='bold padding-b-5'>
            <small>{{ 'GENERIC.reason' | translate | uppercase }}</small>
          </div>
          <div>
            <small>{{ selectedItem.media.reason }}</small>
          </div>
        </div>

        <div class='padding-b-15' *ngIf='selectedItem.media.eventType'>
          <div class='bold padding-b-5'>
            <small>{{ 'REPORTDATA.eventType' | translate | uppercase }}</small>
          </div>
          <div>
            <small>{{ 'REPORTDATA.' + selectedItem.media.eventType | translate }}</small>
          </div>
        </div>

        <div class='padding-b-15' *ngIf='selectedItem.media.eventDate'>
          <div class='bold padding-b-5'>
            <small>{{ 'REPORTDATA.eventDate' | translate | uppercase }}</small>
          </div>
          <div>
            <small>{{ selectedItem.media.eventDate | date: 'yyyy-MM-dd' }}</small>
          </div>
        </div>

        <div class='padding-b-15' *ngIf='selectedItem.media.dateAssigned'>
          <div class='bold padding-b-5'>
            <small>{{ 'REPORTDATA.dateAssigned' | translate | uppercase }}</small>
          </div>
          <div>
            <small>{{ selectedItem.media.dateAssigned | date: 'yyyy-MM-dd' }}</small>
          </div>
        </div>

        <div class='padding-b-15' *ngIf='selectedItem.media.dateCompleted'>
          <div class='bold padding-b-5'>
            <small>{{ 'REPORTDATA.dateCompleted' | translate | uppercase }}</small>
          </div>
          <div>
            <small>{{ selectedItem.media.dateCompleted | date: 'yyyy-MM-dd' }}</small>
          </div>
        </div>

        <div class='padding-b-15' *ngIf='selectedItem.media.rating'>
          <div class='bold padding-b-5'>
            <small>{{ 'REPORTCOLUMNS.Rating' | translate | uppercase }}</small>
          </div>
          <div>
            <small>{{ selectedItem.media.rating }}</small>
          </div>
        </div>

        <div class='padding-b-15' *ngIf='selectedItem.media.organisation'>
          <div class='bold padding-b-5'>
            <small>{{ 'GENERIC.organisation' | translate | uppercase }}</small>
          </div>
          <div>
            <small>{{ selectedItem.media.organisation }}</small>
          </div>
        </div>

        <div class='padding-b-15' *ngIf='selectedItem.media.documentTitle'>
          <div class='bold padding-b-5'>
            <small>{{ 'REPORTDATA.documentTitle' | translate | uppercase }}</small>
          </div>
          <div>
            <small>{{ selectedItem.media.documentTitle }}</small>
          </div>
        </div>

        <div class='padding-b-15' *ngIf='selectedItem.media.uploadedDate'>
          <div class='bold padding-b-5'>
            <small>{{ 'GENERIC.uploaded' | translate | uppercase }}</small>
          </div>
          <div>
            <small>{{ selectedItem.media.uploadedDate | date: 'yyyy-MM-dd' }}</small>
          </div>
        </div>

        <div *ngIf='selectedItem.media.date'>
          <div class='bold padding-b-5'>
            <small>{{ 'GENERIC.date' | translate | uppercase }}</small>
          </div>
          <div>
            <small>{{ selectedItem.media.date | date: 'yyyy-MM-dd' }}</small>
            <small *ngIf='selectedItem.media.time'>{{ selectedItem.media.time }}</small>
          </div>
        </div>
      </div>

      <div class='map-details' *ngIf='selectedItem.map'>
        <div class='padding-b-15'>
          <div class='bold padding-b-5'>
            <small>{{ 'REPORTCOLUMNS.latitude' | translate | uppercase }}</small>
          </div>
          <div>
            <small>{{ selectedItem.map.latitude }}</small>
          </div>
        </div>
        <div class='padding-b-15'>
          <div class='bold padding-b-5'>
            <small>{{ 'REPORTCOLUMNS.longitude' | translate | uppercase }}</small>
          </div>
          <div>
            <small>{{ selectedItem.map.longitude }}</small>
          </div>
        </div>
        <div *ngIf='selectedItem.map.address' class='padding-b-15'>
          <div class='bold padding-b-5'>
            <small>{{ 'REPORTCOLUMNS.address' | translate | uppercase }}</small>
          </div>
          <div>
            <small>{{ selectedItem.map.address }}</small>
          </div>
        </div>
      </div>

      <!-- Image details -->
      <div *ngIf='selectedItem.media?.detailTitle || selectedItem.media?.details' class='image-details' fxFlex>
        <div class='bold padding-b-5'>
          <small>{{ 'GENERIC.damage' | translate | uppercase }}</small>
        </div>
        <div>
          <div class='padding-b-5' *ngIf='selectedItem.media?.detailTitle'>{{ selectedItem.media.detailTitle }}</div>
          <small *ngIf='selectedItem.media?.details'>{{ selectedItem.media.details }}</small>
        </div>
      </div>

      <div class='image-details image-gic-information' fxFlex>
        <div *ngIf="selectedItem.media?.source === 'GIC' && selectedItem.media?.mediaType === mediaTypes.image">
          <div class='bold padding-b-5'>
            <small>{{ 'GICINFORMATION.intelligentDamageDetection' | translate | uppercase }}</small>
          </div>
          <div *ngIf='!selectedItem.media.gicInformation; else IDDInformation'>
            <small>{{ 'GICINFORMATION.noDamageDetected' | translate}}</small>
          </div>
          <ng-template #IDDInformation>
            <div
              *ngFor='let gicData of selectedItem.media.gicInformation'
              fxFlexLayout='row'
              class='gic-data'
            >
              <mat-accordion>
                <mat-expansion-panel>
                  <mat-expansion-panel-header fxFlexLayout='row' fxLayoutAlign='space-between center'>
                    <mat-panel-title class='mat-panel-block'>
                      <div class='gic-information'>
												<span class='bold'>{{
                          'GICINFORMATION.' + gicData.part.name | translate
                          }}</span>
                        &nbsp;
                        <span
                          class='chip'
                          [style.background-color]="
														damageTypeColour[gicData.type] ?? '#7a7a7a'
													"
                        >
													{{ 'GICINFORMATION.' + gicData.type | translate | titlecase }}
												</span>
                      </div>
                      <div class='gic-information padding-t-5'>
												<span>
													{{ 'GICINFORMATION.percentageOfPanel' | translate }}
                          <span class='bold'>
														{{ gicData.dimensions.relativeSize | percent: '1.2-2' }}
													</span>
												</span>
                      </div>
                    </mat-panel-title>
                  </mat-expansion-panel-header>
                  <table class='gic-information'>
                    <tbody>
                    <tr>
                      <td>
                        <span class='bold'>{{ 'GICINFORMATION.Side' | translate }}</span>
                      </td>
                      <td>
													<span>
														{{
                            'GICINFORMATION.' + gicData.part.side
                              | translate
                              | titlecase
                            }}
													</span>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <span class='bold'>{{ 'GICINFORMATION.Width' | translate }}</span>
                      </td>
                      <td>
                        <span>{{ gicData.dimensions.widthInCm }} (cm)</span>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <span class='bold'>{{ 'GICINFORMATION.Height' | translate }}</span>
                      </td>
                      <td>
                        <span>{{ gicData.dimensions.lengthInCm }} (cm)</span>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <span class='bold'>{{ 'GICINFORMATION.Area' | translate }}</span>
                      </td>
                      <td>
                        <span>{{ gicData.dimensions.areaInCmSq }} (cm<sup>2</sup>)</span>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </mat-expansion-panel>
              </mat-accordion>
            </div>
          </ng-template>
        </div>
      </div>
    </div>
  </div>
</div>
